var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-1 my-1",attrs:{"min-width":_vm.minWidth,"flat":""}},[_c('v-row',{staticClass:"ma-1"},[_c('div',{staticClass:"col pa-2"},[(_vm.heading)?_c('h4',{staticClass:"text-truncate text-uppercase"},[_vm._v(_vm._s(_vm.heading))]):_vm._e(),_c('div',{staticClass:"ma-0"},[_vm._t("default")],2)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }